import moment from 'moment';

class TimeHelper {
  runOnceInTimestamp = 0;
  lastCalled = 0;

  wait(miliseconds) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(undefined);
      }, miliseconds)
    });
  }

  formatDay(time) {
    return moment(time).format('DD/MM/YYYY');
  }

  runOnceIn = miliseconds => func => {
    let newTimestamp = new Date().getTime();
    if (newTimestamp - this.runOnceInTimestamp > miliseconds) {
      this.runOnceInTimestamp = newTimestamp;
      if (typeof func === 'function') return func();
    }
  }

  throttle = (func, time = 2000) => {
    return () => {
      const now = Date.now();
      if (now - this.lastCalled > time) {
        func();
        this.lastCalled = now;
      }
    }
  }

  formatTimeAgo(timestamp: Date | string | number): string {
    const now = moment();
    const lastUpdate = moment(timestamp);
    const diffSeconds = now.diff(lastUpdate, 'seconds');
    const diffMinutes = now.diff(lastUpdate, 'minutes');
    const diffHours = now.diff(lastUpdate, 'hours');

    if (diffSeconds < 60) {
      if (diffSeconds === 0) {
        return 'Just now';
      }
      return `${diffSeconds} ${diffSeconds === 1 ? 'second' : 'seconds'} ago`;
    } else if (diffMinutes < 60) {
      return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`;
    } else if (diffHours < 24) {
      return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    } else {
      const diffDays = now.diff(lastUpdate, 'days');
      return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
    }
  }
}

export default new TimeHelper();
